export enum RequestCreatedByType {
  Madar = 'MADAR',
  Admin = 'ADMIN',
  Customer = 'CUSTOMER',
  Fleet = 'FLEET',
  Driver = 'DRIVER',
  Receiver = 'RECEIVER',
  Organization = 'ORGANIZATION',
  Vendor = 'VENDOR',
  Bayan = 'Bayan',
  SuperAdmin = 'SUPER_ADMIN',
}
